module.exports = "data:image/gif;base64,"